export { default } from './SwipeableDrawer';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/SwipeableDrawer/index.js
// module id = 356
// module chunks = 0